export default "__VITE_ASSET__BFjw20yC__"